import React, { useCallback } from "react";
import { ExpandSingle } from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";
import i18n from "~/i18n";

const headerNames = {
  overdue: i18n.t("Overdue"),
  started: i18n.t("Started"),
  tomorrow: i18n.t("Tomorrow"),
  today: i18n.t("Today"),
  restOfWeek: i18n.t("Rest of Week"),
  nextWeek: i18n.t("Next Week"),
  upcoming: i18n.t("Upcoming"),
  notSet: i18n.t("Not Set"),
};

export const UserTaskGroupedByDateListItem = ({ collectionName, count, isExpanded, setExpanded }) => {
  const handleGroupChanged = useCallback(() => {
    setExpanded(collectionName);
  }, [collectionName, setExpanded]);

  return (
    <div>
      <div className="tw-flex tw-items-center tw-justify-start grouped_by_header">
        <ExpandSingle
          expanded={isExpanded}
          onClick={handleGroupChanged}
          className="tw-mr-3 tw-cursor-pointer tw-text-theme-700"
        />
        <div
          className={classnames("group_by_date_name", {
            overdue: collectionName === "overdue",
          })}
        >
          {`${headerNames[collectionName]} (${count})`}
        </div>
      </div>
    </div>
  );
};

UserTaskGroupedByDateListItem.propTypes = {
  collectionName: PropTypes.string.isRequired,
  count: PropTypes.number,
  isExpanded: PropTypes.bool,
  setExpanded: PropTypes.func,
};
